<template>
  <consumer-loan-form
    v-model="form"
    :errors="errors"
    :loading="storing"
    submit-label="Add"
    @submit="store"
  />
</template>
<script>
  import { errorHandler } from '@/extra-functions/store.extra'
  import consumerLoanRepository from '@/repositories/consumer-loan.repository'

  export default {
    name: 'CreateConsumerLoan',
    components: {
      consumerLoanForm: () =>
        import('@/views/dashboard/components/consumer-loans/Form'),
    },
    props: {
      propConsumerId: String,
    },
    data () {
      return {
        form: {
          crNumber: null,
          name: null,
          dateOfReciept: null,
          dateDue: null,
        },
        errors: [],
        storing: false,
      }
    },
    computed: {
      storeId () {
        return this.$store.state.settings.storeId
      },
    },
    methods: {
      store () {
        if (!this.storing) {
          this.storing = true
          this.errors = []
          const id = this.propConsumerId
          const data = {
            id: this.form.crNumber,
            consumer_id: id,
            loanee_name: this.form.name,
            date_loaned: this.form.dateOfReciept,
            date_due: this.form.dateDue,
            store_id: this.storeId,
          }
          consumerLoanRepository.store(id, data)
            .then(() => { this.clearInputs() })
            .catch(errors => { this.errors = errorHandler(errors) })
            .then(() => { this.storing = false })
        }
      },
      // CR number and dates are kept on purpose — this panel is for adding a
      // batch of loans in a row
      clearInputs () {
        this.form = { ...this.form, name: null }
      },
    },
  }
</script>
